module.exports = __webpack_public_path__ + "img/iconYellow.827ce0e3.png";